import React from 'react'

export const FolderIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const [maskId] = React.useState(() => `mask0_${Date.now()}`)
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d='M5.875 8.33178V17.5864C5.875 17.7435 5.92546 17.8726 6.02637 17.9736C6.12744 18.0745 6.2565 18.125 6.41356 18.125H17.5864C17.7435 18.125 17.8726 18.0745 17.9736 17.9736C18.0745 17.8726 18.125 17.7435 18.125 17.5864V8.33178H5.875ZM6.54809 19C6.15653 19 5.80063 18.8399 5.48038 18.5196C5.16013 18.1994 5 17.8435 5 17.4519V8.05069C5 7.88021 5.0272 7.71979 5.08159 7.56944C5.13599 7.41908 5.21758 7.28054 5.32637 7.15381L6.68941 5.51669C6.81614 5.34606 6.97458 5.21729 7.16475 5.13038C7.35492 5.04346 7.55879 5 7.77638 5H16.1899C16.4075 5 16.6142 5.04346 16.8099 5.13038C17.0057 5.21729 17.167 5.34606 17.2937 5.51669L18.6736 7.1875C18.7824 7.31423 18.864 7.45554 18.9184 7.61144C18.9728 7.76748 19 7.93074 19 8.10122V17.4519C19 17.8435 18.8399 18.1994 18.5196 18.5196C18.1994 18.8399 17.8435 19 17.4519 19H6.54809ZM6.20816 7.45678H17.775L16.6106 6.06006C16.5544 6.00406 16.4899 5.95922 16.417 5.92553C16.3441 5.89184 16.2684 5.875 16.1899 5.875H7.79322C7.71476 5.875 7.63907 5.89184 7.56616 5.92553C7.49324 5.95922 7.42871 6.00406 7.37256 6.06006L6.20816 7.45678Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
